import { InputTypes } from "components/form/input";
import validator from "validator";
import { QuoteInterface } from "../confirmation/Confirmation.types";
import { FieldProps } from "components/form/input";

export interface CalculatorState {
  form: {
    groupSize: FieldProps;
    pickUpAddress: FieldProps;
    dropOffAddress: FieldProps;
    pickupTime?: FieldProps;
  };
  formValid: boolean;
  formSubmitted: boolean;
  quote?: QuoteInterface;
}

export const defaultCalculatorState: CalculatorState = {
  form: {
    groupSize: {
      value: "",
      valid: false,
    },
    pickUpAddress: {
      value: "",
      valid: false,
    },
    dropOffAddress: {
      value: "",
      valid: false,
    },
  },
  formValid: false,
  formSubmitted: false,
};

export interface FormFieldsProps<Params> {
  fieldName: string;
  label: string;
  type?: InputTypes;
  col?: string;
  validationRule?: (props: Params) => boolean;
  disabled?: (props: Params) => boolean;
  required?: boolean;
  tooltip?: string;
  value?: string;
}

export const formFields: FormFieldsProps<string | number>[] = [
  {
    fieldName: "pickUpAddress",
    label: "Pick Up Street Address",
    type: "place",
    tooltip: "Enter an address or name of a bar",
  },
  {
    fieldName: "dropOffAddress",
    label: "Drop Off Street Address",
    type: "place",
    tooltip: "Enter an address or name of a bar",
  },
  {
    fieldName: "groupSize",
    label: "Number of Passengers",
    type: "number",
    col: "col-md-6",
  },
];
